import { DimensionsType } from 'api/responses/models/Unit/UnitMeasurement';
import { TFunction } from 'i18next';

export const dimensionTypes = (
	t: TFunction<'unitCreation'>
): { id: DimensionsType; label: string }[] => [
	{ id: 'Estimated', label: t('weight-type-estimated') },
	{ id: 'Actual', label: t('weight-type-actual') },
];
